<template>
    <div class="siderbar">
        <el-scrollbar wrap-class="scrollbar-wrapper">
            <el-menu
                background-color="#545c64"
                text-color="#fff"
                active-text-color="#ffd04b"
                :default-active="onRoutes"
                unique-opened
                router>
                <!-- 一级菜单 -->
                <template v-for="(item, index) in getMenu">
                    <template v-if="item.children">
                        <el-submenu
                            :index="item.name"
                            :key="index">
                            <template slot="title">
                                <icon-svg :name="item.icon"></icon-svg>
                                <span class="item-name">{{item.name}}</span>
                            </template>
                            <!-- 二级菜单 -->
                            <template v-for="(subItem, subIndex) in item.children">
                                <template v-if="!subItem.hidden">
                                    <el-menu-item
                                        :index="subItem.path"
                                        :key="subIndex">
                                        <span class="sub-name">{{subItem.name}}</span>
                                    </el-menu-item>
                                </template>
                            </template>
                        </el-submenu>
                    </template>
                    <template v-else>
                        <el-menu-item
                            :index="item.path"
                            :key="index">
                            <span class="item-name">{{item.name}}</span>
                        </el-menu-item>
                    </template>
                </template>
            </el-menu>
        </el-scrollbar>
    </div>
</template>

<script>
import siderbar from './siderbar.js';
export default {
    ...siderbar
};
</script>

<style src="./siderbar.css" scoped></style>




// WEBPACK FOOTER //
// src/views/common/siderbar/siderbar.vue